import { render } from "./DirektoriAdmin.vue?vue&type=template&id=22da3a8a"
import script from "./DirektoriAdmin.vue?vue&type=script&lang=js"
export * from "./DirektoriAdmin.vue?vue&type=script&lang=js"

import "./DirektoriAdmin.vue?vue&type=style&index=0&id=22da3a8a&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__